import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "sonner";
import HomePage from "@/pages/HomePage";
import LandingPage from "@/pages/LandingPage";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import ProvjeraPage from "@/pages/ProvjeraPage";
import Ponuda1Page from "@/pages/Ponuda1Page";
import MetaPixel from "@/components/MetaPixel";

function App() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.1,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    window.__lenis = lenis;

    const onClick = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const id = a.getAttribute("href");
      if (id.length > 1) {
        const el = document.querySelector(id);
        if (el) {
          e.preventDefault();
          lenis.scrollTo(el, { offset: -80 });
        }
      }
    };
    document.addEventListener("click", onClick);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      delete window.__lenis;
      document.removeEventListener("click", onClick);
    };
  }, []);

  return (
    <div className="App">
      <div className="grain" aria-hidden="true" />
      <Toaster position="top-center" theme="dark" richColors />
      <BrowserRouter>
        <MetaPixel />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/oglasi" element={<LandingPage />} />
          <Route path="/termin" element={<LandingPage />} />
          <Route path="/provjera" element={<ProvjeraPage />} />
          <Route path="/ponuda1" element={<Ponuda1Page />} />
          <Route path="/privatnost" element={<PrivacyPolicy />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
